import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import url from 'front-end-core/core/url'
import { QA_CONTENT } from 'constants/controllers'
import { startsWith } from 'libraries/lodash'
import { createRoot } from 'react-dom/client'
import Icon from './Icon'
import { parseHtmlContent } from 'helpers/parseHtmlContent'
import { useSelector } from 'react-redux'
import selectFlavour from 'redux/selectors/selectFlavour'
import selectAolName from 'redux/selectors/selectAolName'

const DOCUMENT_HREF = /href="([^"]+)"/g
const TOC_ID = /"#([\d]+_Toc[\d]+|[a-zA-Z0-9]{10})"/

const Xml = ({
  sectionId = '',
  component = 'span',
  className = '',
  styles,
  render
}) => {
  const containerRef = useRef()
  const flavour = useSelector(selectFlavour)
  const aol = useSelector(selectAolName)

  useEffect(() => {
    [...containerRef.current.querySelectorAll('[class^=\'icon-\']')]
      .forEach(iconContainer => {
        const [name] = iconContainer.className.match(/icon-[^\s]+/)
        const root = createRoot(iconContainer)
        root.render(<Icon name={name} />)
      })
  }, [containerRef])

  const __html = render.replace(DOCUMENT_HREF, (phrase) => {
    if (TOC_ID.test(phrase)) {
      return phrase.replace(TOC_ID, (phrase, focusedId) => `"${url(QA_CONTENT, { aol, flavour, sectionId, focusedId })}"`)
    } else if (startsWith(phrase, 'href="#')) {
      return phrase
    } else {
      return `${phrase} target="_blank" rel="noopener noreferrer"`
    }
  })

  const html = parseHtmlContent(__html)

  if (component === 'div') {
    return (
      <div ref={containerRef} style={styles} className={className}>
        {html}
      </div>
    )
  } else {
    return (
      <span ref={containerRef} style={styles} className={className}>
        {html}
      </span>
    )
  }
}

Xml.propTypes = {
  render: PropTypes.string.isRequired,
  styles: PropTypes.any
}

export default Xml
